
export class UpdateNonscheduleBO {
    id: string;
    employeeId: string|null;
    startTime: string | null;
    endTime: string | null;
    startDate: string | null;
    scheduleStatusLid: string | null;
}

export class updatecalendarschedule {
    eventId :string = "00000000-0000-0000-0000-000000000000";
    consultantId : string = "00000000-0000-0000-0000-000000000000";
    // eventDate: string;
    startTime : string;
    endTime : string;
    clientId : string = "00000000-0000-0000-0000-000000000000";
    getConfirmation : boolean= false;
}

export class GetcalendarBO{
     clientId : string = "00000000-0000-0000-0000-000000000000";
     consultantId : string = "00000000-0000-0000-0000-000000000000";
     startDate : string |null;
     endDate : string |null ;
     
}
